module.exports = __webpack_public_path__ + "static/media/Bildstatistik.8f7f0841.jpg";